export enum Sort {
	Asc = 'ASC',
	Desc = 'DESC',
}
